module.exports = __webpack_public_path__ + "img/operator.b3fae459.svg";